import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DataRoomShareableLink } from 'models/ShareableLink';
import { Button } from 'ncoded-component-library';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import EyeIcon from 'icons/Eye.icon';
import ClipboardcopyIcon from 'icons/Clipboardcopy.icon';
import { getResolveUrl, getShareableLinkRoute } from 'utils';

import './SecureLinkEmpty.styles.scss';

type SecureLinkEmptyProps = {
  className?: string;
  link: DataRoomShareableLink;
};

const SecureLinkEmpty: React.FC<SecureLinkEmptyProps> = (props) => {
  const { className, link } = props;

  const classes = classNames('secure-link-empty', 'white-panel', className);

  const { _id, isActive } = link || {};

  const { t } = useTranslation();

  const copyToClipboard = useCopyToClipboard();

  return (
    <div className={classes}>
      <span>
        <EyeIcon />
      </span>
      <p>{t('noActivityYet')}</p>
      <p>
        {t(
          isActive
            ? 'thisSecureLinkHasntBeenAccessed'
            : 'thisSecureLinkHasBeenArchived',
        )}
      </p>
      {isActive && (
        <Button
          variant="outline"
          icon={ClipboardcopyIcon}
          onClick={(e) =>
            copyToClipboard(e, getResolveUrl(getShareableLinkRoute(_id)))
          }
        >
          {t('copyLink')}
        </Button>
      )}
    </div>
  );
};

export default SecureLinkEmpty;
